import { render, staticRenderFns } from "./InspectOrder.vue?vue&type=template&id=bc0e0644&scoped=true"
import script from "./InspectOrder.vue?vue&type=script&lang=js"
export * from "./InspectOrder.vue?vue&type=script&lang=js"
import style0 from "./InspectOrder.vue?vue&type=style&index=0&id=bc0e0644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0e0644",
  null
  
)

export default component.exports